import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import "../ProfileStyle.css";
import FormFieldGroup from "components/form/label/FormFieldGroup";
const HesCredentialsView = ({ register, handleSubmit, errors, editable, setEditable, saveBtnText, cancelBtnText, onSaveCallback, showCancelBtn, isDirty }) => {
	return (
		<div className="pageCard">
			<div className="pCardHead">
				{!editable && (
					<button className="frmEditBtn" onClick={() => setEditable(true)}>
						Edit
					</button>
				)}
			</div>
			<div className="pCardbody">
				<Form className="formArea">
					<p className="frmSmtext">Credentials</p>
					<Row>
						<Col md="6">
							<FormFieldGroup
								controlId="hes_assessor_id"
								label="HES Assessor ID"
								type="text"
								placeholder="HES Assessor ID"
								className="inputField bdr2"
								readOnly={!editable}
								register={register}
								name="hes_assessor_id"
								error={errors.hes_assessor_id}
							/>
						</Col>
						<Col md="6">
							<FormFieldGroup
								controlId="hes_password"
								label="HES Password"
								type="password"
								placeholder="HES Password"
								className="inputField bdr2"
								readOnly={!editable}
								register={register}
								name="hes_password"
								error={errors.hes_password}
							/>
						</Col>
					</Row>
					{editable && (
						<Row>
							<Col md="12 d-flex align-items-center justify-content-end gap-4 footerBtnBar">
								{showCancelBtn && (
									<button
										className="bdrBtn mrLauto cancelBtn"
										type="button"
										onClick={() => {
											setEditable(false);
										}}
									>
										{cancelBtnText}
									</button>
								)}
								{isDirty && (
									<button
										className="fillPrimarBtn "
										type="button"
										onClick={() =>
											handleSubmit(() => {
												onSaveCallback();
												setEditable(false);
											})
										}
									>
										{saveBtnText}
									</button>
								)}
							</Col>
						</Row>
					)}
				</Form>
			</div>
		</div>
	);
};

export default HesCredentialsView;
